module.exports = __webpack_public_path__ + "img/yiduiyi05.c18d9f67.jpg";